import { createChannel } from "APP_ROOT/cable";

let channel = null;

export function unsubscribe() {
  if (channel) {
    channel.unsubscribe();
    channel = null;
  }
}

export function onDisconnect() {
  return unsubscribe();
}

export function subscribe(connection = createChannel()) {
  if (!channel) {
    const { listen } = connection;

    channel = listen("NotificationChannel", { onDisconnect });
  }
}



// WEBPACK FOOTER //
// ./app/channels/notification.js